export interface WakeMessage {
  taskId: string;
  firedAt: Date;
  message: string;
}

const WAKE_HEADER = /\[Scheduled notification (\S+) fired at (\S+)\] ?/g;

const toRfc3339 = (date: Date): string => date.toISOString().replace(/\.\d{3}Z$/, 'Z');

export function formatWakeMessage({ taskId, firedAt, message }: WakeMessage): string {
  return `[Scheduled notification ${taskId} fired at ${toRfc3339(firedAt)}] ${message}`;
}

export function parseWakeMessages(content: string): WakeMessage[] {
  const headers = [...content.matchAll(WAKE_HEADER)];
  if (headers[0]?.index !== 0) return [];

  const wakes = headers.map((header, i) => ({
    taskId: header[1],
    firedAt: new Date(header[2]),
    message: content.slice(header.index + header[0].length, headers[i + 1]?.index).trim(),
  }));

  return wakes.some((wake) => Number.isNaN(wake.firedAt.getTime())) ? [] : wakes;
}
